export function formatNumber<T>(value: number | undefined | null, digits: number, defaultValue: T): T | number {
  if (typeof value === "number") {
    return parseFloat(value.toFixed(digits))
  }

  return defaultValue
}
